import { useCzechSuklRsAtcGroupsMetadata } from '~/libs/infrastructure/api/availability';

export function useAvailabilityMetadata() {
	const { data, isLoading, isError } = useCzechSuklRsAtcGroupsMetadata();

	return {
		metadata: data,
		isLoading,
		isError,
	};
}
